module.exports = __webpack_public_path__ + "static/img/logo05.bb62e8ed.png";